import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminlogindashboard',
  templateUrl: './adminlogindashboard.component.html',
  styleUrls: ['./adminlogindashboard.component.scss']
})
export class AdminlogindashboardComponent implements OnInit {

  admUserDetails: any;

  constructor() {
    this.admUserDetails = JSON.parse(localStorage.getItem('admLoginDetails'));
   }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/admin/adminlogindashboard/adminlogindashboard.component.ts